import LiteralExpressionAdapter from './LiteralExpressionAdapter';

export default {
  __init__: [ 'literalExpressionAdapter' ],
  literalExpressionAdapter: [ 'type', LiteralExpressionAdapter ]
};